type Filter = 'all' | 'tests' | 'supplements' | 'bundles';
type Category = 'tests' | 'supplements' | 'other' | 'bundles';
type ProductHandles = Array<string>;

export function initFilter(): void {
  const filter = getFilterFromURL();
  const products = getProductsFromURL();
  filterProductsInDOM(filter);
  filterPullProductsToTop(products);
  addFilterButtonEventListener();
  listenForFilterUpdate();
}

function getProductsFromURL(): ProductHandles {
  const url = window.location;
  const searchQuery = new URLSearchParams(url.search);
  const products = searchQuery.get('products');
  return (products?.split(',') as ProductHandles) || [];
}

function filterPullProductsToTop(products: ProductHandles): void {
  if (!products.length) {
    return;
  }

  const productWrapper = document.querySelector('.product-list');
  const productItems = document.querySelectorAll(
    '.browse-product-card, .bundled-products'
  );

  if (productItems) {
    const itemsToMove: Record<string, HTMLElement> = {};
    productItems.forEach((item) => {
      if (!(item instanceof HTMLElement)) {
        return;
      }

      const productID = item?.getAttribute('data-product-handle');
      if (productID && products.includes(productID)) {
        itemsToMove[productID] = item;
      }
    });
    products.reverse().forEach((product: string) => {
      if (product in itemsToMove) {
        productWrapper?.prepend(itemsToMove[product]);
      }
    });
  }
}

function addFilterButtonEventListener(): void {
  const buttonsWrapper = document.querySelector('.filter-buttons');
  buttonsWrapper?.addEventListener('click', (e) => {
    const clickedEl = e.target as HTMLElement;

    if (clickedEl.matches('button')) {
      const slectedFilter = clickedEl.dataset.filter;
      const newUrl = new URL(window.location.href);

      newUrl.search = `?prod-category=${slectedFilter}`;
      window.history.pushState(null, '', newUrl.href);
    }
  });
}

function getFilterFromURL(): Filter {
  const url = window.location;
  const searchQuery = new URLSearchParams(url.search);
  const filter = searchQuery.get('prod-category');
  return filter?.trim().replace(/\/$/, '') as Filter;
}

function listenForFilterUpdate(): void {
  window.addEventListener('locationchange', () => {
    const filter = getFilterFromURL();
    filterProductsInDOM(filter);
  });
}

function filterProductsInDOM(filter: Filter): void {
  if (filter === 'tests') {
    showCategory('tests');
  } else if (filter === 'supplements') {
    showCategory('supplements');
  } else if (filter === 'bundles') {
    showCategory('bundles');
  } else {
    showAll();
  }
}

function showAll(): void {
  setActiveClassOnFilterButton('all');
  $('.not-shown-all').hide();
  $('[data-product-category]:not(.not-shown-all)').fadeIn(300);
  document.querySelector('.product-list')?.setAttribute('data-selected', 'all');

  unsetFilteredView();
}

function showCategory(category: Filter & Category): void {
  setActiveClassOnFilterButton(category);
  fadeInOrFadeOut(category);
  document
    .querySelector('.product-list')
    ?.setAttribute('data-selected', category);
  setFilteredView();
}

function setFilteredView(): void {
  const mainWrapper = document.querySelector('#page-shop-all');
  mainWrapper?.classList.add('filtered-view');
}

function unsetFilteredView(): void {
  const mainWrapper = document.querySelector('#page-shop-all');
  mainWrapper?.classList.remove('filtered-view');
}

function setActiveClassOnFilterButton(filter: Filter): void {
  const currentlyActive = document.querySelector('button[data-filter].active');
  const buttonByDataFilter = document.querySelector(
    `button[data-filter="${filter}"]`
  );
  currentlyActive?.classList.remove('active');
  currentlyActive?.setAttribute('aria-current', 'false');
  buttonByDataFilter?.classList.add('active');
  buttonByDataFilter?.setAttribute('aria-current', 'true');
}

function fadeInOrFadeOut(category: Category): void {
  $('[data-product-category]').fadeOut(150);

  document
    .querySelectorAll(`[data-product-category*="${category}"]`)
    ?.forEach((el) => $(el).fadeIn(150));
}
